import { useTranslation } from 'gatsby-plugin-react-i18next';

import React, { useEffect, useRef, useState } from 'react';
import Button from '@atoms/Button/Button';
import Title from '@atoms/Title/Title';
import Link from '@components/Link';
import CookieImg from '../../images/cookie.svg';
import './CookieBtn.scss';

const CookieBtn = () => {
    const { t } = useTranslation();
    const myBlock = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    const saveInLocaleStorage = (key, value) => {
        if (typeof Storage !== 'undefined' && typeof window !== 'undefined') {
            localStorage.setItem(key, value);
        } else {
            console.log('local storage is not supported');
        }
    };

    const handleAccept = (e) => {
        saveInLocaleStorage('cookie_accepted', 'true');

        setIsVisible(false);
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsVisible(true);
        }, 400);
        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div
            className={`CookieBtn ${isVisible ? 'is-visible' : ''}`}
            ref={myBlock}
        >
            <div className="CookieBtn--inner">
                <div className="CookieBtn--item">
                    <CookieImg />
                </div>
                <div className="CookieBtn--item">
                    <Title size="xxs">{t('cookie.warning')}</Title>

                    <Link
                        to="/cookie-policy"
                        target="_blank"
                        nonce={undefined}
                        onResize={undefined}
                        onResizeCapture={undefined}
                    >
                        <Button
                            label={t('learn.more')}
                            size="s"
                            variant="inline"
                        />
                    </Link>
                </div>
            </div>

            <div>
                <Button
                    align="center"
                    variant="outlined"
                    size="s"
                    label={t('generic.close')}
                    onClick={handleAccept}
                />
            </div>
        </div>
    );
};

export default CookieBtn;
